import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch, ref } from 'vue'
import { IonToast } from '@ionic/vue'
import { checkmarkCircleOutline } from 'ionicons/icons'

import { useControlStore } from '@/store/control'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageToast',
  setup(__props) {

const control = useControlStore()

const showToast = ref(false)
const toastDuration = ref(2500)

watch(
  () => control.message,
  () => {
    showToast.value = true
    setTimeout(() => {
      control.$patch({ message: null })
      showToast.value = false
    }, toastDuration.value)
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonToast), {
    "is-open": showToast.value,
    icon: _unref(checkmarkCircleOutline),
    message: _unref(control).message,
    duration: toastDuration.value,
    position: "top",
    cssClass: "toast-message"
  }, null, 8, ["is-open", "icon", "message", "duration"]))
}
}

})